import { format } from "date-fns";
import { useEffect, useState } from "react";
import API_ROUTES from "~/api-routes";
import apiService from "~/services/service";

export interface Event {
  id: string;
  name: string;
  due_date: string;
  type: string;
  entityId: string;
  entityName: string;
  entityCountry: string;
  processId: string;
  processName: string;
  serviceId: string;
  serviceName: string;
  primary_color: string;
  secondary_color: string;
  statusName: string;
  statusCode: string;
}

const useUpcomingEvents = () => {
  const [eventsData, setEventsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchUpcomingEvents();
  }, []);

  const fetchUpcomingEvents = async () => {
    try {
      setIsLoading(true);
      const { data } = await apiService(
        API_ROUTES.FETCH_UPCOMING_EVENTS,
        "GET",
      );
      setEventsData(data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const formatDueDate = (dateString: string) => {
    if (dateString) {
      return format(dateString, "MMMM do, yyyy");
    } else {
      ("-");
    }
  };

  return {
    eventsData,
    isLoading,
    formatDueDate,
  };
};

export default useUpcomingEvents;
